module.exports = __webpack_public_path__ + "img/tips8.c58e47c1.png";